import { IconCircleCheckFilled } from '@bbr/icons/circle-check-filled';
import { IconX } from '@bbr/icons/x-outline';
import { children, For, Show } from 'solid-js';
import { Transition } from 'solid-transition-group';
import { ActivityIndicator } from '../components/activity-indicator.tsx';
import { useFormContext } from './form.tsx';
import type { JSX, ParentProps } from 'solid-js';

type Props = ParentProps<{
	pending?: boolean;
	pendingMessage?: JSX.Element;
	success?: boolean;
	successMessage?: JSX.Element;
	error?: boolean;
	errorMessages?: Array<string>;
}>;

export function FormSubmission(props: Props) {
	const success = children(() => (props.successMessage ? props.successMessage : null));
	const { data, hasChanges, errors } = useFormContext();

	return (
		<div class="relative flex min-h-min grow flex-row items-center justify-start">
			<Transition
				mode="outin"
				enterClass="opacity-0"
				enterToClass="opacity-100 animate-in zoom-in anim-duration-500"
				exitToClass="animate-out zoom-out anim-duration-500"
			>
				<Show when={data().pending || props.pending}>
					<div class="absolute top-1">
						<ActivityIndicator layout="horizontal">{props.pendingMessage}</ActivityIndicator>
					</div>
				</Show>
			</Transition>
			<Transition
				mode="outin"
				enterClass="opacity-0"
				enterToClass="opacity-100 animate-in fade-in anim-duration-200"
				exitToClass="animate-out fade-out slide-out-to-right anim-duration-200"
			>
				<Show when={(!!data().result && !hasChanges()) || props.success}>
					<div
						role="alert"
						aria-live="polite"
						class="flex h-full flex-row items-baseline gap-2 rounded text-emerald-600 dark:text-emerald-400"
					>
						<IconCircleCheckFilled class="relative top-1 shrink-0" />
						<p>{success() || ' '}</p>
					</div>
				</Show>
			</Transition>
			<Transition
				mode="outin"
				enterClass="opacity-0"
				enterToClass="opacity-100 animate-in fade-in anim-duration-200"
				exitToClass="animate-out fade-out slide-out-to-right anim-duration-200"
			>
				<Show when={(!!data().error && !hasChanges()) || props.error}>
					<div class="flex h-full flex-row items-baseline gap-2 text-rose-500">
						<IconX class="relative top-1 shrink-0" />
						<ul role="alert" aria-live="polite" class="flex flex-col">
							<For each={props.errorMessages ? [...props.errorMessages, ...errors()] : errors()}>
								{(err) => <li>{err}</li>}
							</For>
						</ul>
					</div>
				</Show>
			</Transition>
		</div>
	);
}
